import React from 'react';
import "./notFound.scss";

export default function NotFound() {
    return (
    <div class="container-404">
	<h1>An error as occured.</h1>
	<h1> <span class="ascii">{"(╯°□°）╯︵ ┻━┻"}</span></h1>
	<a href="/">Go back homepage</a>
</div>
);
}
